module.exports = __webpack_public_path__ + "static/NW_KP_Bild_Lands_1_a_Eng-939dbf1d4c21a897832f9aeae5878f4b.jpg";